import { render } from "./PTApply.vue?vue&type=template&id=017147dd&scoped=true"
import script from "./PTApply.vue?vue&type=script&lang=js"
export * from "./PTApply.vue?vue&type=script&lang=js"

import "./PTApply.vue?vue&type=style&index=0&id=017147dd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017147dd"]])

export default __exports__